import React from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import Layout from '../../components/en/common/Layout'
import { MetaData } from '../../components/common/meta'
import HeroFullScreenPhoto from '../../components/sections/hero-full-screen-photo'
import Partnerships from '../../components/en/common/partnerships'
import OurPartners from '../../components/sections/our-partners'
import Testimonials from '../../components/en/sections/testimonials-static'
import WhyThinkPlus from '../../components/en/sections/why-think-plus'
import SectionHeader from '../../components/common/section-header'
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import ContactForm from '../../components/en/sections/contact-form'

import '../../styles/pages/page-landingpage.scss'
import schema from '../../utils/schema/en/faq'
import { videography as servicesSchema } from '../../utils/schema/en/services'

const pageVideoProduction = ({ location }) => {
  const data = require("../../utils/schema/en/pages/videoProduction.json")
  const images = useStaticQuery(graphql`{
  hero: file(relativePath: {eq: "hero/hero-landingvideography.jpg"}) {
    childImageSharp {
      gatsbyImageData(quality: 90, layout: FULL_WIDTH)
    }
  }
  caseStudiesCynvestco: file(
    relativePath: {eq: "landingvideography/CaseStudiesCynvestco.png"}
  ) {
    childImageSharp {
      gatsbyImageData(width: 664, layout: CONSTRAINED)
    }
  }
  caseStudiesMaki: file(
    relativePath: {eq: "landingvideography/CaseStudiesMaki.png"}
  ) {
    childImageSharp {
      gatsbyImageData(width: 664, layout: CONSTRAINED)
    }
  }
  caseStudiesShowreel: file(
    relativePath: {eq: "landingvideography/CaseStudiesShowreel.png"}
  ) {
    childImageSharp {
      gatsbyImageData(width: 664, layout: CONSTRAINED)
    }
  }
  caseStudiesWhatIf: file(
    relativePath: {eq: "landingvideography/CaseStudiesWhatIf.png"}
  ) {
    childImageSharp {
      gatsbyImageData(width: 664, layout: CONSTRAINED)
    }
  }
}
`)

  return <>
      <MetaData
        data={data}
        location={location}
        type="website"
        linkAlternate={false}
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema.faqVideography)}</script>
        <script type="application/ld+json">{JSON.stringify(servicesSchema)}</script>
        <link rel="alternate" href="https://think-plus.gr/think-videography/" hreflang="el-gr" />
        <link rel="alternate" href="https://think-plus.gr/en/video-production/" hreflang="en" />
      </Helmet>
      <Layout viewport={'full'}>
        <article className="landing-page">
          <HeroFullScreenPhoto
            heroImage={images.hero.childImageSharp.gatsbyImageData}
            heroContent={
              `<div class="landing-page__heading">
                <h1>VIDEO PRODUCTION</h1>
                <h2>1 minute video = 1.8 million words</h2>
              </div>
              <div class="landing-page__heading-cta">
                <p class="h6 dec-element--line-horizontal">Call us at +30 210 6101478 <a href="tel: +302106101478" class="btn__theme ml-md-3 mt-3 mt-md-0">Call us</a></p>
                <p class="h6 dec-element--line-horizontal">or fill out this form and we will get back to you as soon as possible <a href="#contact_form_section" class="btn__theme ml-md-3 mt-3 mt-md-0">Contact form</a></p>
              </div>`
            }
          />
          <section className="landing-page__info background__theme text-align-center">
            <div className="container medium">
              <div className="row">
                <div className="col mb-5">
                  <h2><strong>Video Content Creation</strong></h2>
                  <p className="h6">Among all the types of content a business can create, <br />video is the medium, that records giant growth.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <h3 className="h6">
                    By 2020, video will represent <br />
                    <strong className="h2">82%</strong> <br />
                    of total consumer online traffic
                  </h3>
                </div>
                <div className="col-md-4">
                  <h3 className="h6">
                    <strong className="h2">7 out of 10</strong> <br />
                    people will likely be more receptive to businesses and brand names, whose videos they have spent time watching
                  </h3>
                </div>
              </div>
            </div>
          </section>
          <section className="why-wordpress text-align-center">
            <div className="container medium">
              <header>
                <p className="h6">What could a business say to its audience</p>
                <p className="h2 dec-header--underline">with a video?</p>
              </header>
              <p>The answer is 1.8 million words and non-verbal messages per minute, not just any video. The content of the video should be created with inspiration and strategically communicate a clear message.  At Think Plus we know exactly how to plan and create video content, which will then be aimed at the target audience.</p>
              <hr className="hr--theme hr--small" />
              <h2>Corporate video, viral videos, <br />music video clips, commercial &amp; advertising videos</h2>
              <p>are just a few video content types which Think Plus specializes in.</p>
            </div>
          </section>
          <section className="what-we-offer background__theme">
            <div className="container medium">
              <header className="text-align-center">
                <h2 className="dec-header--underline">VIDEO SERVICES</h2>
              </header>
              <div className="row checkmarks">
                <div className="col-md-6">
                  <p>Project Management and Casting Direction.</p>
                  <p>Overview of the shooting locations and renting the right venues, buildings, etc.</p>
                  <p>Script Writing Production and Photography Director.</p>
                  <p>Direction and full project management.</p>
                  <p>Post Production Services, Technical video and audio editing - Mixing Editing.</p>
                  <p>Styling Direction and makeup services - Make up, Styling.</p>
                  <p>Research / Study / Concept Video structure design, selection and purchase of stock footage rights, insert supers texts etc.</p>
                  <p>Audio Studio - Voice-Over, recording and subtitling - with full technical recording processing as well as study, selection of music rights.</p>
                </div>
                <div className="col-md-6">
                  <p>Production of promotional video.</p>
                  <p>Professional audio and video equipment, camera, drone, microphones, lighting, etc.</p>
                  <p>Cast Services: Sound Recorder - Booman, Cameraman, Speaker, Presenter, Illustration Workshop, Operator.</p>
                  <p>Technical support for proper operation, at all times, both for the website and for the e-mail accounts.</p>
                  <p>Post Production edit, Color Correction, Titles and Motion Graphics.</p>
                  <p>Design and creation of 3D graphics, Animations, After Effects, Illustration, Promotional Graphs and characters.</p>
                </div>
              </div>
            </div>
          </section>
          <section className="landing-page__faq">
            <div className="background__theme--dark">
              <SectionHeader
                title="Videography"
                text="FAQ"
              />
            </div>
            <div className="container medium">
              <div className="row">
                <div className="col-md-6">
                  <Accordion 
                    className="accordion--theme"
                    allowZeroExpanded={true}
                  >
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>How much does a video cost?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>There is no specific answer to this question. The value of a video has to do with a lot of factors, such as its script, the choice of actors and contributors, its use (TV or Web) and especially the goal it wants to achieve (Awareness, sales, tutorial, corporate, funding, etc). However, with one visit to our offices, we know that we will answer all of your questions.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Can I get a sample of your work?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Of course you can as we are very proud of the collaboration we have. On our website in the category "Video &amp; Photography" you will find the latest showreel which is a selected sample of several different works we have implemented. Corporate videos, TV, video clips, animations, events, etc.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>What is Live Streaming?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Live streaming is the real time streaming of video over the internet by using any device that can record video, whether it is a professional video camera or a simple camera, web cam, tablet or smartphone. Thanks to the rapid development of the relevant technology and the expansion of the live streaming services market, anyone can now retransmit live video from where it is located, with competitive quality and without any unwanted complications. All it has to do is choose the right live streaming service, the equipment it will use to "capture" its video, as well as the content of its transmission, which it will share with its potential audience in order to fix it on its "channel". For others it is their talent, for others it is an event worth spreading and for others it is an event that "happens now" and "seeks" eyewitnesses.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Why is Live Streaming so important to every brand?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>If, however, live streaming changes the role of the user-viewer in the process of creating and spreading video content on the Internet, one can easily imagine how useful such a tool can be for a professional or a company who wants to enrich its narrative. to expand its recognition and to charm its audience. Original and quality video that connects the viewer with the "moment" and possibility of "participation" through his favorite social media accounts can help him become actively involved in the campaigns that concern him. With content marketing remaining an ever-changing field of action for marketing strategists and content providers alike, the ability to communicate the "superiority" of a brand with the main weapon being the power and prestige of a live video is a major challenge, especially for content creators and content creators alike. It is also an opportunity to interact directly and effectively with the younger, technologically advanced generation, who have learned to be in constant visual contact with what they are interested in, as well as to respond in a variety of ways to the stimuli they receive through the platform they use. Indicatively, according to research, Generation Z members (young people born after the mid-1990s) enter YouTube and social media daily, prefer live streaming to other TV services, and enjoy multitasking while they watch videos in the vast majority, in percentages that reach 90%. Of course, in order to approach the public in a way that will lead to measurable responses and substantial conversions to tangible goals, it's not enough to use one of the available live streaming services and simply organize a live broadcast of the show to be a part of the public experience. An event designed for everyone to see (or even an audience able to make a successful live campaign) must be well organized and have adequate coverage of a proper TV campaign, high quality video and sound and well-designed flow, in order to keep the interest and not to motivate the audience to "change channels”.</p>
                        <p>Think Plus, having entered the market of live streaming services dynamically, offers a flexible transmission system with multiple coverage through Full HD cameras that adapts to any space and successfully meets the highest requirements, in direction, quality, speed and connectivity. Even in places with limited or no internet connection, Think Plus live streaming services use 4G technology to deliver 100% of their capabilities whenever and wherever necessary.</p>
                      </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Do you undertake live streaming coverage?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Yes, all kinds of streaming in every region of Greece. Huge brands and organizations have already trusted us either to present their new product or to cover an extremely important conference.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>How to take advantage of videos via Instagram?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>Creating content for IGTV doesn't have to be fancy - as effective. Let's look at some ideas that can be applied in these early stages of IGTV and level up your business.</p>
                        <ol>
                          <li>
                            <header><strong>Q&amp;A’s</strong></header>
                            <p>Interviews and Q&amp;A’s with industry leaders or with people in your organization or business can, if done right, offer great value to your audience. This is also the simplest and easiest way to get started with IGTV and explore its potential, without time constraints or the risk of bad connections and live video interruptions.</p>
                          </li>
                          <li>
                            <header><strong>Intros</strong></header>
                            <p>This is the most popular tactic on YouTube and is even more valuable on IGTV, especially thanks to its uniqueness of playing videos directly with what the user enters. A good introductory video can help your visitors understand who you are, what you do and what exactly they can expect from you on your IGTV channel or on your Instagram profile.</p>
                          </li>
                          <li>
                            <header><strong>Tutorials</strong></header>
                            <p>Tutorials and webinars are the best way to educate your audience about how to use a product or service. Creating an online library of useful information can be beneficial for branding but also for building your credibility on a particular topic.</p>
                          </li>
                          <li>
                            <header><strong>Content republishing</strong></header>
                            <p>Another great idea you can use for your brand or business is to republish other videos and place them on your IGTV channel. This process may require some editing, especially if your video was originally created for horizontal viewing, but it's also the best way to extend the life of videos for more than 24 hours on Stories and Live.</p>
                          </li>
                        </ol>
                        <strong>At Think Plus we closely monitor developments on social media.</strong>
                        <p>IGTV is a rather new tool that, with proper use, can pay off in the long run and bring your business one step ahead of the competition. But as it is the latest addition to an ever-changing landscape in which there are so many different components to success, you need the guidance of an expert in the field to help you grow and make a substantial profit.</p>
                        <p>Think Plus is closely following all the new developments in the field of social media from the moment of their creation and we know exactly how to adapt to each case, with equally successful results. At the same time, we have extensive and long-term experience in video production for marketing purposes and we are ready to apply our know-how to the vertical form of IGTV. Your cooperation with us will highlight your company and this can be guaranteed by the award-winning success stories we have gone through so far! Perhaps, you can be the next success story?</p>
                      </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Do you undertake all kinds of videos?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Yes, whatever kind of video you want and for any use and purpose, our experienced production team will provide you with the solution. So whether it is corporate videos, TV, video clips, animation, events, promotional or crowdfunding, plan a visit to our offices and we will guide you accordingly.</p></AccordionItemPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="col-md-6">
                <Accordion 
                    className="accordion--theme"
                    allowZeroExpanded={true}
                  >
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Do you have a studio?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Yes, we have a studio properly equipped for photography, video with green screen capability and recording studio.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>What is the process for producing a video?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>We have a very specialized staff in the area of video production with many years of experience. In the pre-production stage, we design the style and structure of the video. Based on your aesthetics and goals, our creative department drafts up the storyboard (storytelling, animation or natural persons, casting), and we present it to you for approval. This is followed by the production stage where the shooting or the composition of images take place (in case no shooting is required). In the post production stage, our experienced editors make the final touches (color corrections, add effects and graphics, sound mixing) and transfer the corporate video to the appropriate media for its distribution.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Do you also undertake voice over / speakage?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Of course, we also have a large sample of selections in Greek speakers but also in many other languages.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>What kind of equipment do you use?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Think Plus has state-of-the-art equipment capable of meeting every need, whatever it might be.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Do you also promote Video?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>We 'mix' the viral trend with marketing strategies, and create effective viral video campaigns with strong interaction. We approach the target group and share the video on websites and social media that bring the maximum possible engagement! Choose Think Plus to promote your video and become the new viral star of your audience!</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                      <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Why choose Think Plus to produce my own video?</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>We create corporate videos that fully correspond to your company's image and values. But we don't stop there. We provide a comprehensive Video Marketing strategy that will ensure your success. We are by your side, from the moment you create a video to the reports that will accompany the end of the marketing campaign. We have renowned and experienced partners and of course the innovative look that characterizes our company and every service we offer separately is a testament to our commitment to our business.</p></AccordionItemPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </div>
          </section>
          <Partnerships />
          <OurPartners headerTitle="CLIENTS" />
          <Testimonials classname="background__theme--dark" />
          <section className="landing-page__case-studies background__theme">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6 order-2 order-md-0">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">THINK PLUS</h2>
                    <h3 className="h4">Showreel 2019</h3>
                    <p>Unique content for customers who trust us with their digital presence.</p>
                  </div>
                </div>
                <div className="col-md-6 order-1 order-md-0 background__white background-bleed__right">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={images.caseStudiesShowreel.childImageSharp.gatsbyImageData}
                      alt="Think Plus" />
                    <a href="https://www.youtube.com/watch?v=94ueJSH1aoI" title="Showreel" className="btn--more" target="_blank">View video <span>&rarr;</span></a>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 background__white background-bleed__left">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={images.caseStudiesMaki.childImageSharp.gatsbyImageData}
                      alt="Maki Philosophy" />
                    <a href="https://www.youtube.com/watch?v=nYfK4fXvagY" title="TV Spot" className="btn--more" target="_blank">View video <span>&rarr;</span></a>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">MAKI PHILOSOPHY</h2>
                    <h3 className="h4">TV Spot</h3>
                    <p>The video is based on the idea of changing the balance and using special techniques to move the camera.</p>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 order-2 order-md-0">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">CYNVESTCO REAL ESTATE</h2>
                    <h3 className="h4">Corporate Promotional Video</h3>
                    <p>Think Plus seals Cynvestco Real Estate's entry into the Greek market.</p>
                  </div>
                </div>
                <div className="col-md-6 order-1 order-md-0 background__white background-bleed__right">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={images.caseStudiesCynvestco.childImageSharp.gatsbyImageData}
                      alt="Cynvestco" />
                    <a href="https://www.youtube.com/watch?v=WScmphsGaD0" title="Corporate promotional" className="btn--more" target="_blank">View video <span>&rarr;</span></a>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 background__white background-bleed__left">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={images.caseStudiesWhatIf.childImageSharp.gatsbyImageData}
                      alt="INCLUSIVE GREEN GROWTH" />
                    <a href="https://www.youtube.com/watch?v=wq7GkkXyvbM" title="Promotional" className="btn--more" target="_blank">View video <span>&rarr;</span></a>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">INCLUSIVE GREEN GROWTH</h2>
                    <h3 className="h4">Promotional Video</h3>
                    <p>3D Animation and creative thinking in a spectacular result!</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <WhyThinkPlus />
          <ContactForm />
        </article>
      </Layout>
    </>;
}

export default pageVideoProduction
